import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const HistoriaPage = lazy(() => import('../pages/historia/page'));
const MenuPage = lazy(() => import('../pages/menu/page'));
const CateringPage = lazy(() => import('../pages/catering/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const TerminosPage = lazy(() => import('../pages/terminos/page'));
const PrivacidadPage = lazy(() => import('../pages/privacidad/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/historia',
    element: <HistoriaPage />,
  },
  {
    path: '/menu',
    element: <MenuPage />,
  },
  {
    path: '/catering',
    element: <CateringPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/terminos',
    element: <TerminosPage />,
  },
  {
    path: '/privacidad',
    element: <PrivacidadPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;